import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppearanceService } from '../../core/services/appearance/appearance.service';

@Component({
  selector: 'app-onboarding-shell',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './onboarding-shell.html',
  styleUrl: './onboarding-shell.scss',
})
export class OnboardingShell {
  constructor() {
    inject(AppearanceService);
  }
}
